import { all } from "@redux-saga/core/effects"
import registerSaga from './register'
import activateSaga from './activate'
import routeOverwatchSaga from "./routeOverwatch"
import invitationSaga from "./invitation"
import redirectExternalSaga from "./redirectExternal"
import claimsUpdateOverwatchSaga from "./claimsUpdateOverwatch"
import temporalRouteTraceSaga from "./temporalRouteTrace"
import resetLoadingIndicatorSaga from "./resetLoadingIndicator"
import keepPositiveSaga from "./keepPositive"
import { AuthProvider } from "ra-core"

const allOdSagas = (authProvider:AuthProvider) => function* () {
  yield all([
    registerSaga(),
    activateSaga(),
    invitationSaga(),
    routeOverwatchSaga(),
    redirectExternalSaga(),
    claimsUpdateOverwatchSaga(),
    temporalRouteTraceSaga(),
    resetLoadingIndicatorSaga(),
    keepPositiveSaga(authProvider),
  ])
}

export default allOdSagas
